import { render, staticRenderFns } from "./SelfHosted.vue?vue&type=template&id=235b8dd2&scoped=true"
import script from "./SelfHosted.vue?vue&type=script&lang=ts"
export * from "./SelfHosted.vue?vue&type=script&lang=ts"
import style0 from "./SelfHosted.vue?vue&type=style&index=0&id=235b8dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235b8dd2",
  null
  
)

export default component.exports